import { action } from 'satcheljs';
import FindRecipientPersonaType from 'owa-recipient-common/lib/store/schema/FindRecipientPersonaType';

export default action('ONE_RECIPIENT_SELECTED_ACTION', (persona: FindRecipientPersonaType) => {
    return {
        persona,
    };
});
